// extracted by mini-css-extract-plugin
export default {"container":"VerifyEmail_container__M+dmq","text":"VerifyEmail_text__Daaq5"};